import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { 
  Lock, 
  Users, 
  ClipboardList, 
  ClipboardCheck, 
  Settings, 
  DollarSign, 
  FileText, 
  Building, 
  Truck, 
  BarChart3,
  RotateCcw,
  PackageCheck
} from 'lucide-react';
import NASSunjinMonitor from './NASSunjinMonitor';
import NASCustomers from './NASCustomers';
import NASCustomerOrders from './NASCustomerOrders';
import NASOrderApproval from './NASOrderApproval';
import NASPOSAdmin from './NASPOSAdmin';
import NASPayments from './NASPayments';
import NASInvoices from './NASInvoices';
import NASBankDeposits from './NASBankDeposits';
import NASDeliveries from './NASDeliveries';
import NASReports from './NASReports';
import NASRefundHistory from './NASRefundHistory';
import NASDeliveryConfirmation from './NASDeliveryConfirmation';

const AdminHub = () => {
  const [activeTab, setActiveTab] = useState('sunjin-monitor');

  const tabs = [
    { id: 'sunjin-monitor', label: 'Sunjin Monitor', icon: Lock, component: NASSunjinMonitor },
    { id: 'customers', label: 'Customers', icon: Users, component: NASCustomers },
    { id: 'customer-orders', label: 'Customer Orders', icon: ClipboardList, component: NASCustomerOrders },
    { id: 'order-approval', label: 'Order Approval', icon: ClipboardCheck, component: NASOrderApproval },
    { id: 'delivery-confirm', label: 'Delivery Confirm', icon: PackageCheck, component: NASDeliveryConfirmation },
    { id: 'pos-admin', label: 'POS Admin', icon: Settings, component: NASPOSAdmin },
    { id: 'refund-history', label: 'Refund History', icon: RotateCcw, component: NASRefundHistory },
    { id: 'payments', label: 'Payments', icon: DollarSign, component: NASPayments },
    { id: 'invoices', label: 'Invoices', icon: FileText, component: NASInvoices },
    { id: 'bank-deposits', label: 'Bank Deposits', icon: Building, component: NASBankDeposits },
    { id: 'deliveries', label: 'Deliveries', icon: Truck, component: NASDeliveries },
    { id: 'reports', label: 'Reports', icon: BarChart3, component: NASReports },
  ];

  const ActiveComponent = tabs.find(t => t.id === activeTab)?.component;

  return (
    <div className="p-4 lg:p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Admin</h1>
        <p className="text-slate-500">Manage customers, orders, payments, and reports</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <div className="overflow-x-auto pb-2 -mx-4 px-4">
          <TabsList className="inline-flex h-auto p-1 bg-slate-100 rounded-lg min-w-max">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <TabsTrigger 
                  key={tab.id}
                  value={tab.id} 
                  className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium whitespace-nowrap data-[state=active]:bg-white data-[state=active]:shadow-sm"
                  data-testid={`admin-tab-${tab.id}`}
                >
                  <Icon size={16} />
                  <span>{tab.label}</span>
                </TabsTrigger>
              );
            })}
          </TabsList>
        </div>

        {tabs.map((tab) => {
          const Component = tab.component;
          return (
            <TabsContent key={tab.id} value={tab.id} className="mt-4">
              <Component />
            </TabsContent>
          );
        })}
      </Tabs>
    </div>
  );
};

export default AdminHub;
